/* Product Gallery 1.5.3. No cart, product data or native slider mutations. */
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');
  function initialize() {
    document.querySelectorAll('template[data-iu-gallery-template]').forEach(template => {
      const section = document.getElementById('ProductSection-' + template.dataset.iuGalleryTemplate);
      const host = section?.querySelector('[data-image-gallery]');
      const wrapper = host?.querySelector('.productView-image-wrapper');
      if (!desktop.matches || !wrapper || host.querySelector('.iu-gallery-pair')) return;
      const fragment = template.content.cloneNode(true);
      const gallery = fragment.querySelector('.iu-gallery-pair');
      const dialog = gallery.querySelector('dialog');
      if (typeof dialog.showModal !== 'function') return;
      const photos = [...gallery.querySelectorAll('[data-iu-full]')];
      const large = gallery.querySelector('[data-iu-large]');
      const detail = gallery.querySelector('[data-iu-detail]');
      const hint = gallery.querySelector('[data-iu-zoom-hint]');
      function setZoom(active) {
        detail.setAttribute('aria-pressed', String(active));
        detail.setAttribute('aria-label', active ? 'Revino la fotografia întreagă' : 'Mărește detaliile fotografiei');
        hint.textContent = active ? 'Mișcă cursorul pentru detalii · clic pentru revenire' : 'Clic pe fotografie pentru detalii';
        detail.style.setProperty('--iu-zoom-x', '50%');
        detail.style.setProperty('--iu-zoom-y', '50%');
      }
      function positionZoom(target, event) {
        const bounds = target.getBoundingClientRect();
        target.style.setProperty('--iu-zoom-x', `${Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100))}%`);
        target.style.setProperty('--iu-zoom-y', `${Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100))}%`);
      }
      gallery.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse' || detail.getAttribute('aria-pressed') !== 'true') return;
        const target = event.target.closest('[data-iu-detail]');
        if (target) positionZoom(target, event);
      });
      let current = 0;
      let opener;
      let previousOverflow;
      function show(index) {
        setZoom(false);
        current = (index + photos.length) % photos.length;
        large.src = photos[current].dataset.iuFull;
        large.alt = photos[current].querySelector('img').alt;
        gallery.querySelector('[data-iu-counter]').textContent = `${current + 1} / ${photos.length}`;
      }
      gallery.addEventListener('click', event => {
        const target = event.target.closest('button');
        if (!target) return;
        if (target.hasAttribute('data-iu-photo')) {
          opener = target;
          show(Number(target.dataset.iuPhoto));
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        } else if (target.hasAttribute('data-iu-detail')) {
          setZoom(detail.getAttribute('aria-pressed') !== 'true');
          if (event.detail > 0) positionZoom(detail, event);
        } else if (target.hasAttribute('data-iu-close')) dialog.close();
        else if (target.hasAttribute('data-iu-prev')) show(current - 1);
        else if (target.hasAttribute('data-iu-next')) show(current + 1);
      });
      dialog.addEventListener('keydown', event => {
        if (detail.getAttribute('aria-pressed') === 'true' && event.target === detail && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
          event.preventDefault();
          const axis = event.key === 'ArrowLeft' || event.key === 'ArrowRight' ? '--iu-zoom-x' : '--iu-zoom-y';
          const step = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -10 : 10;
          const parsed = parseFloat(detail.style.getPropertyValue(axis));
          const value = Number.isFinite(parsed) ? parsed : 50;
          detail.style.setProperty(axis, `${Math.max(0, Math.min(100, value + step))}%`);
          return;
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(current + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow || '';
        if (desktop.matches) opener?.focus();
      });
      desktop.addEventListener('change', () => { if (!desktop.matches && dialog.open) dialog.close(); });
      wrapper.append(fragment);
      host.classList.add('iu-pair-ready');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  desktop.addEventListener('change', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
